<template>
    <div>

        <vs-table v-if="!loading && reports.length != 0" :data="reports.data" stripe>

            <template #thead>
                <vs-th>#</vs-th>
                <vs-th>Movie</vs-th>
                <vs-th>Subject</vs-th>
                <vs-th>date</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-for="(report, index) in  data" :key="index" v-if="report.movie">
                        <vs-td class="img-container" v-if="report.movie">
                            <img :src="report.movie.poster" class="product-img" width="50px" />
                        </vs-td>
                        <vs-td>
                            <div v-if="report.movie">{{ report.movie.en_title }}</div>
                        </vs-td>
                        <vs-td>{{ report.subject_title }}</vs-td>
                        <vs-td>{{ report.date }}</vs-td>
                        <vs-td>
                            <vs-chip v-if="report.status == 0" color="orange">
                                Pending
                            </vs-chip>
                            <vs-chip v-if="report.status == 2" color="danger">
                                Refused
                            </vs-chip>
                            <vs-chip v-if="report.status == 1" color="success">
                                Approved
                            </vs-chip>
                        </vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <!-- <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(story)" /> -->
                            <!-- <feather-icon :icon="story.status==1?'EyeOffIcon':'EyeIcon'" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="changeStatus(story)" /> -->
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(report)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination v-if="reports.length != 0" :total="reports.last_page" v-model="page"></vs-pagination>
    </div>
</template>
<script>
export default {
    data() {
        return {
            reports: [],
            report: [],
            page: 1,
            query: '',
            loading: false,
        }
    },
    created() {
        this.getReports()
    },
    watch: {
        page() {
            this.getReports();
        },
        query(val) {
            this.getReports();
        },
    },
    methods: {
        del() {
            this.axios.post(`${this.$apiUrl}/v2/reports/delete/${this.report.id}`).then(res => {
                this.report = [];
                if (res.status == 200) {
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Record Deleted !',
                        text: ''
                    })
                }
                this.page = 1;
                this.getReports();
            })

        },
        close() {
            this.report = [];
        },
        openConfirm(report) {
            this.report = report;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Delete Report`,
                text: 'Are you sure to delete this item ?',
                accept: this.del,
                close: this.close
            })
        },
        getReports() {
           // this.loading = true;
            this.axios.get(`${this.$apiUrl}/v2/reports?page=${this.page}`).then(res => {
                this.reports = res.data;
                this.loading = false;
            })
        }
    },
}
</script>